import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { Icon } from 'src/components/atoms'
import styles from './styles.module.scss'

export type AppTableAddRowButtonProps = {
  onClick: () => void
} & React.StyledProps

export const AppTableAddRowButton: React.StyledFC<
  AppTableAddRowButtonProps
> = ({ onClick }: AppTableAddRowButtonProps) => {
  return (
    <Box className={styles.buttonWrapper}>
      <Button className={styles.button} onClick={onClick}>
        <Icon icon="plus" />
        <Typography variant="body1">空行を追加</Typography>
      </Button>
    </Box>
  )
}
